'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIPopoverHeader;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _colors = require('HubStyleTokens/colors');

var _misc = require('HubStyleTokens/misc');

var _sizes = require('HubStyleTokens/sizes');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _PopoverContext = require('../context/PopoverContext');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _UIPopoverCloseButton = require('./UIPopoverCloseButton');

var _UIPopoverCloseButton2 = _interopRequireDefault(_UIPopoverCloseButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Header = _styledComponents2.default.header.withConfig({
  displayName: 'UIPopoverHeader__Header'
})(['display:flex;justify-content:space-between;align-items:flex-start;background:inherit;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:inherit;border-top-right-radius:inherit;padding:', ';', ';h1,h2,h3,h4,h5,h6{', '}'], function (_ref) {
  var flush = _ref.flush,
      popoverUse = _ref.popoverUse;

  if (flush) return '0';
  if (popoverUse === 'longform') return _sizes.POPOVER_PADDING_Y + ' ' + _sizes.TOOLTIP_LONGFORM_PADDING + ' 0';
  if (popoverUse === 'shepherd') return _sizes.SHEPHERD_PADDING_Y + ' ' + _sizes.POPOVER_PADDING_X;
  return _sizes.POPOVER_PADDING_Y + ' ' + _sizes.POPOVER_PADDING_X + ' 0';
}, function (_ref2) {
  var popoverUse = _ref2.popoverUse;
  return popoverUse === 'shepherd' && (0, _styledComponents.css)(['background:', ';border-top-right-radius:inherit;border-top-left-radius:inherit;color:', ';'], _colors.THUNDERDOME, _colors.OLAF);
}, function (_ref3) {
  var popoverUse = _ref3.popoverUse;

  if (popoverUse === 'longform') return (0, _styledComponents.css)(['font-size:', ';font-weight:', ';text-transform:none;margin-bottom:8px;'], _sizes.HEADING5, _misc.HEADING_WEIGHT5);
  return 'margin-bottom: 0';
});

function UIPopoverHeader(_ref4) {
  var className = _ref4.className,
      children = _ref4.children,
      onOpenChange = _ref4.onOpenChange,
      showCloseButton = _ref4.showCloseButton,
      rest = _objectWithoutProperties(_ref4, ['className', 'children', 'onOpenChange', 'showCloseButton']);

  var popoverUse = (0, _react.useContext)(_PopoverContext.PopoverContext).use;

  return _react2.default.createElement(
    Header,
    _extends({}, rest, {
      className: (0, _classnames2.default)('uiPopoverHeader private-popover__header', className),
      popoverUse: popoverUse
    }),
    children,
    showCloseButton && _react2.default.createElement(_UIPopoverCloseButton2.default, {
      popoverUse: popoverUse,
      onClick: function onClick() {
        if (onOpenChange) onOpenChange((0, _SyntheticEvent2.default)(false));
      }
    })
  );
}

UIPopoverHeader.propTypes = {
  children: _propTypes2.default.node,
  flush: _propTypes2.default.bool,
  showCloseButton: _propTypes2.default.bool,
  onOpenChange: _propTypes2.default.func
};

UIPopoverHeader.displayName = 'UIPopoverHeader';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/tooltip/UIPopoverHeader.js
// module id = 472
// module chunks = 177